import { createSlice } from '@reduxjs/toolkit';

interface StockCacheState {
  ratings: Record<string, number>;
  prices: Record<string, { min: number; max: number }>;
}

const initialState: StockCacheState = {
  ratings: {},
  prices: {},
};

const stocksCacheSlice = createSlice({
  name: 'stocksCache',
  initialState,
  reducers: {
    setStockData(state, action) {
      const { articleId, rating, price } = action.payload;
      state.ratings[articleId] = rating;
      state.prices[articleId] = price;
    },
    resetStocksCache: () => initialState,
  },
});

export const { setStockData, resetStocksCache } = stocksCacheSlice.actions;
export default stocksCacheSlice.reducer;